var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoginPage==false)?_c('div',{staticStyle:{"width":"100%","height":"100vh","display":"flex"}},[_c('leftnav'),_c('div',{staticClass:"right-content"},[_c('pagehead'),_c('router-view')],1)],1):_c('div',[_c('loginPage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }